<template>
    <div class="row">
        <div class="col-md-4">
            Item:<br/>
            <select class="proceedToCheckoutItem form-control" v-model="proceedToCheckoutItem">
                <option value="">--select one--</option>
                <optgroup label="Packages">
                    <option v-for="pack in packages" :value="'k-'+pack.package_id" :key="pack.package_id">{{ getPackageData(pack.package_id, 'name') }}</option>
                </optgroup>
                <optgroup label="Deals">
                    <option v-for="deal in deals" :value="'d-'+deal.deal_id" :key="deal.deal_id">{{ getDealData(deal.deal_id, 'name') }}</option>
                </optgroup>
                <optgroup label="Products">
                    <option v-for="product in products" :value="'p-'+product.product_id" :key="product.product_id">{{ getProductData(product.product_id, 'name') }}</option>
                </optgroup>
            </select>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            allpackages: Array,
            alldeals: Array,
            allproducts: Array,
            packages: Array,
            deals: Array,
            products: Array,
            rule: Object
        },
        data: () => {
            return {
                proceedToCheckoutItem: ''
            }
        },
        methods: {
            getPackageData(pack_id, type) {
                let pack_details = this.allpackages.filter(function(pack) {
                                return pack.id === pack_id
                            })[0]
                return pack_details ? pack_details[type] : '';
            },
            getDealData(deal_id, type) {
                let deal_details = this.alldeals.filter(function(deal) {
                                return deal.id === deal_id
                            })[0]
                return deal_details ? deal_details[type] : '';
            },
            getProductData(product_id, type) {
                let product_details = this.allproducts.filter(function(product) {
                                return product.id === product_id
                            })[0]
                return product_details ? product_details[type] : '';
            },
            selectProceedToCheckoutItem() {
                if(this.rule.settings.package_id) {
                    this.proceedToCheckoutItem = 'k-'+this.rule.settings.package_id;
                } else if(this.rule.settings.deal_id) {
                    this.proceedToCheckoutItem = 'd-'+this.rule.settings.deal_id;
                } else if(this.rule.settings.product_id) {
                    this.proceedToCheckoutItem = 'p-'+this.rule.settings.product_id;
                }
            },
            updateProceedToCheckoutItem() {
                var packageId = '';
                var dealId = '';
                var productId = '';
                if(this.proceedToCheckoutItem) {
                    var typeItem = this.proceedToCheckoutItem.split('-');
                    if( typeItem[0] == 'k' ) {
                        packageId = Number(typeItem[1]);
                    }else if( typeItem[0] == 'd' ) {
                        dealId = Number(typeItem[1]);
                    }else if( typeItem[0] == 'p' ) {
                        productId  = Number(typeItem[1]);
                    }
                }
                this.rule.settings = {
                    package_id: packageId,
                    deal_id: dealId,
                    product_id: productId
                }
            }
        },
        mounted() {
            this.selectProceedToCheckoutItem();
        },
        watch: {
            proceedToCheckoutItem() {
                this.updateProceedToCheckoutItem();
            }
        }
    }
</script>